const ROUTE_PATHS = {
    LOGIN: "/login",
    TRANSACTION_SCHEDULE: "/transaction-schedule",
    TRANSACTION_SCHEDULE_DASHBOARD: "/transaction-schedule/dashboard",
    TRANSACTION_PLAN: "/transaction-plan",
    SETUP_IMPORT: "/setup-import",
    UPLOAD_EXCEL_ACC: "/upload-excel",
    ACCOUNT_STATEMENTS: "/account-statements/:id",
    ACCOUNT_DETAIL: "/account/:bankAccountId",
    INSTITUTION_ACCOUNTS: "/institutions/:institutionId/accounts",
    INSTITUTION_HEAD_ACCOUNTS: "/institutions/:institutionId/head-accounts",
    INSTITUTION_WALLETS: "/institutions/:institutionId/wallets",
    MANAGE_INSTITUTIONS: "/manage/institutions",
    TRANSACTION_DATA_TABLE: "/transaction-data",
    SEARCH_STATEMENTS: "/search-statements",
    USERS: "/users",
    ADMIN_INSTITUTIONS: "/admin/institutions",
    ADMIN_ACCOUNTS: "/admin/institutions/:institutionId",
    INSTITUTION_ANALYTICS: "/institutions/:institutionId/analytics",
};

export default ROUTE_PATHS;